import { GetObjectHelperBase } from './GetObjectHelperBase';
export class GetSymbolObjectHelper extends GetObjectHelperBase {
    constructor() {
        super(...arguments);
        this.index = 1;
    }
}

//# sourceMappingURL=GetSymbolObjectHelper.js.map
